<template>
  <section class="recruit-content">
    <!-- <Department v-for="(obj, index) in list" :key="index" :dept="obj"/> -->
    <section class="contact">
      <BaseButton tag="router-link" size="hero" :to="contactLink">{{ pr.contact }}</BaseButton>
    </section>
  </section>
</template>

<script>
import { computed, inject } from 'vue';
import BaseButton from '@/components/common/BaseButton.vue';
import usePageResource from '@/composables/usePageResource';
// import Department from './Department.vue';

export default {
  name: 'recruit-content',
  components: {
    BaseButton,
    // Department,
  },
  setup() {
    const { pr } = usePageResource('recruit');
    const locale = inject('locale');
    const localeValue = computed(() => locale?.value || '');
    const contactLink = computed(() => ({
      name: 'contact-us',
      params: {
        lang: localeValue.value || undefined,
      },
    }));

    return {
      pr,
      contactLink,
    };
  },
  computed: {
    // list() {
    //   return this.pr.list;
    // },
  },
};
</script>

<style scoped lang="scss">
.recruit-content {
  margin: 0 auto 79px;
  // padding-bottom: 52px;
  // max-width: 1230px;
  // background-color: #fff;

  .contact {
    text-align: center;
  }

  @media only screen and (max-width: 1230px) {
    margin-bottom: 0;
    padding-bottom: 70px;
  }
}
</style>
